module.exports = {


	new: {
		1: 'Home',
		2: 'About',
		3: 'Service',
		4: 'Q&A',
		5: 'Partner',
		6: 'language',
		7: 'Integrated Service Platform',
		8: 'Dedicated to',
		'8_2': 'driving',
		'8_3': 'Cryptocurrency',
		'8_4': ' Development',
		9: 'Best Quality / Most Professional / Most Efficient',
		10: 'Learn more',
		11: 'Our Instruments',
		12: 'Teammates',
		13: 'Projects',
		14: 'Experience',
		15: 'About',
		'15_2': 'Block Change',
		16: 'Established in 2019 and headquartered ',
		'16_2':'in Hong Kong, China,',
		'16_3':'Block Change is a marketing and development-integrated encryption organization ',
		'16_4':'focused on helping projects address a wide range of needs and problems.',
		17: 'Our team has been in the blockchain industry for years, bringing your cryptocurrency tokens to',
		'17_2':' new heights, helping ',
		'17_3':'multiple blockchain customers ',
		'17_4':'succeed',
		18: 'Vision of Block Change',
		19: '" Promoting the cryptocurrency industry',
		20: 'and making it easy for ordinary people to get involved "',
		21: 'We provide ',
		'21_2': 'specialized services',
		22: 'Composed of experienced personnel',
		23: 'Brand building',
		24: 'Selection of project track, overall image design',
		25: 'Content authoring',
		26: 'Creative content stories increase visibility',
		27: 'Create Contract',
		28: 'Smart contract development and website creation',
		29: 'Consultant',
		30: 'Advise and develop strategies for projects',
		31: 'Social Platforms',
		32: 'Telegram / Discord / Twitter Platform Building Management',
		33: 'Media KOL promotion',
		34: 'Opinion Leaders and Industry Media Increase Influence',
		35: 'List of Listed Security',
		36: 'Exchanges, Audit, Coinmarketcap',
		37: 'Event Planning',
		38: 'Online and offline events to promote growth',
		39: 'Creative Publications',
		40: 'Ad design and production (video, GIF, PNG)',
		41: 'software develop ',
		'41_2': 'services',
		42: 'Mature Technical Team Operations',
		43: 'Contract<br>testing',
		44: 'IDO',
		45: 'DEFI',
		46: 'Luquid<br>Pool',
		47: 'DEX',
		48: 'NFT',
		49: 'Smart<br>Contract',
		50: 'Token',
		51: 'Farm',
		52: 'Deployment',
		53: 'The People We Serve',
		54: 'Global Distribution',
		55: 'Partner',
		56: 'Frequently Asked Questions',
		57: 'Here are some of the most frequent questions we get asked.',
		58: '',
		'58_2': 'Committed to providing for projects',
		59: 'Social-media',
		60: 'Contact us / ',
		'60_2': 'Support@BlockChange.Dev',
		q1: 'How much does it cost to build and develop a brand?',
		q2: 'How long does the overall project launch time take?',
		q3: 'What other support is available after launch?',
		q4: 'Does BlockChange have its own platform?',
		a1: "It depends on the customer's project needs, please contact us to discuss and give a quotation.",
		a2: 'It usually takes 1-3 weeks. At the same time, the needs of each project are different, and it is normal for the time to fluctuate up and down. The specific time needs to be confirmed after communicating with us, and we will give a detailed schedule.',
		a3: 'Listed DEX exchange and platforms such as CMC, CG, KOL related promotion services are requested.',
		a4: 'We have our own tool platform that can be used by users and project parties.',

	},
	ball: {
		1: 'Contract<br>testing',
		2: 'IDO',
		3: 'DEFI',
		4: 'Luquid<br>Pool',
		5: 'DEX',
		6: 'NFT',
		7: 'Smart<br>Contract',
		8: 'Token',
		9: 'Farm',
		10: 'Deployment',
	},
	tip: {
		1: "Successful purchase",
		2: "Purchase failed",
		3: "Received successfully",
		4: "Failed to receive",
		5: "Participation succeeded",
		6: 'Participation failed',
		7: "Pre-sale not open",
		8: "Please select the pre-sale amount",
		9: "Insufficient balance",
		10: "Authorization failed",
		11: "Not open for collection"
	},
}